import "./views/clipboard_button_view"
import "./views/email_share_manual_view"
import "./views/friend_landing_page_view"
import "./views/friend_signposting_view"
import "./views/login_view"
import "./views/mobile_sharing_view"
import "./views/post_purchase_tracking_claim_submission_view"
import "./views/post_purchase_tracking_signup_view"
import "./views/referral_status_view"
import "./views/referrer_popover_view"
import "./views/share_tabs_view"
import "./views/share_view"
import "./views/splash_view"
import "./views/stats_view"
import "./views/twitter_view"
import "./views/webmail_sharing_view"
